import React from "react";
import styles from "./styles.module.scss";
import { Button } from "../../../../shared/Button/Button";
import { CircularProgress } from "../../../../shared/CircularProgress/CircularProgress";
import { Input } from "../../../../shared/Input/Input";
import { uiNotification } from "../../../../services/UINotificationService";
import { useBasicSignupSendOtpMutation } from "../../../../api/mutations/useBasicSignupSendOtpMutation";
import { useBasicSignupVerifyOtpMutation } from "../../../../api/mutations/useBasicSignupVerifyOtpMutation";
import { AlertBox } from "../../../../shared/AlertBox/AlertBox";

export const SignupOtp = ({ phoneNumber, onVerify }) => {
  const [otp, setOtp] = React.useState("");
  const [isSent, setIsSent] = React.useState(false);
  const [verifiedNumber, setVerifiedNumber] = React.useState("");

  const send = useBasicSignupSendOtpMutation({
    onSuccess: () => {
      uiNotification.success("OTP sent successfully");
      setIsSent(true);
      setVerifiedNumber("");
      setOtp("");
    },
    onError: () => {
      uiNotification.error("Failed to send OTP. Try again later.");
    },
  });

  const verify = useBasicSignupVerifyOtpMutation({
    onSuccess: () => {
      uiNotification.success("Phone number verified successfully");
      setVerifiedNumber(phoneNumber);
      setIsSent(false);
      setOtp("");
      onVerify(phoneNumber);
    },
    onError: () => {
      uiNotification.error("Failed to verify OTP. Try again.");
      setOtp("");
      setVerifiedNumber("");
    },
  });

  const handleVerify = () => {
    if (!otp.trim()) return uiNotification.error("Please enter OTP");
    if (/^\d+$/.test(otp)) {
      verify.mutate({ phone_number: phoneNumber, otp });
    } else {
      uiNotification.error("OTP should contain only numbers");
    }
  };

  const isVerified =
    verifiedNumber === phoneNumber && verifiedNumber.trim().length > 0;

  const canSend = phoneNumber?.trim()?.length > 8 && !isVerified;

  return (
    <div className={styles.root}>
      {isVerified ? (
        <AlertBox size="small" variant="success">
          Phone number has been successfully verified.
        </AlertBox>
      ) : (
        <>
          <div className={styles.buttons}>
            <Button
              size="small"
              isDisabled={!canSend || send.isLoading}
              onClick={() =>
                canSend && send.mutate({ phone_number: phoneNumber })
              }
              leftAdornment={
                send.isLoading ? (
                  <CircularProgress size="tiny" color="white" />
                ) : null
              }
            >
              {isSent ? "Resend OTP" : "Send OTP"}
            </Button>
            {isSent && (
              <Button
                size="small"
                color="success"
                onClick={handleVerify}
                isDisabled={verify.isLoading}
                leftAdornment={
                  verify.isLoading ? (
                    <CircularProgress size="tiny" color="white" />
                  ) : null
                }
              >
                Verify
              </Button>
            )}
          </div>
          {isSent && !isVerified && (
            <Input
              autoFocus
              size="small"
              placeholder="Enter OTP"
              isDisabled={verify.isLoading}
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
          )}
        </>
      )}
    </div>
  );
};
